import {openLoginRegistrationPopup} from "@/libs/helpers.ts"

export function bindUserMenuBtn(pinia) {
    const userIcon = document.querySelector("#btn-login")
    const userMenu = document.querySelector(".has-sub-menu")
    let isUserMenuOpen = false
    let loginAppLoaded = false
    let loginAppInitPromise: Promise<void> | null = null

    if (userIcon) {
        userIcon.addEventListener(
            "click",
            async (e) => {
                e.preventDefault()
                toggleUserMenu(userIcon)
                await initLoginAppIfNeeded(pinia)
                openLoginRegistrationPopup("login")
            },
            {passive: false}
        )
    }

    document.addEventListener(
        "click",
        (e) => {
            const target = e.target as HTMLElement
            if (isUserMenuOpen && userMenu && !userMenu.contains(target) && !userIcon.contains(target)) {
                toggleUserMenu(userIcon)
            }
        },
        {passive: true}
    )

    document.addEventListener(
        "click",
        async (e) => {
            const target = e.target as HTMLElement
            if (isFormInteraction(target)) {
                e.preventDefault()
                await initLoginAppIfNeeded(pinia)
            }
        },
        {passive: false}
    )

    function isFormInteraction(target: HTMLElement): boolean {
        return target.matches(
            "form.test-account .tutkit-email, .wp-block-tutkit-email-form .tutkit-email, form.test-account button, .wp-block-tutkit-email-form button"
        )
    }

    async function initLoginAppIfNeeded(pinia) {
        if (!loginAppLoaded && !loginAppInitPromise) {
            loginAppInitPromise = import("@/site-header/vueApps.ts").then(({initLoginVueApp}) => {
                initLoginVueApp(pinia, true)
                loginAppLoaded = true
            })
        }
        return loginAppInitPromise
    }

    function toggleUserMenu(userIcon) {
        const liItem = userIcon.closest(".has-sub-menu")
        if (liItem) {
            isUserMenuOpen = !isUserMenuOpen
            liItem.classList.toggle("open-sub-menu")
            liItem.querySelector("ul").classList.toggle("open-sublist-menu")
        }
    }
}
